<template>
  <v-list-item v-if="!isEditing" ripple class="it-hv">
    <v-list-item-avatar class="my-0">
      <v-icon small>fal fa-flag</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-subtitle class="caption" v-if="!isPrintEmpty">国籍</v-list-item-subtitle>
      <v-list-item-title>{{ printNationality }}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading" @click="edit">
            <v-icon small>fal fa-pencil</v-icon>
          </v-btn>
        </template>
        <span>編集する</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
  <v-container v-else>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3">
        <v-select
          v-model="form.nationality.content"
          label="国籍"
          item-text="label"
          item-value="code"
          :rules="rules.nationality"
          :items="getNationItems"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  name: 'clientAboutBasicNationality',
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      form: {
        nationality: {
          id: '',
          content: ''
        }
      },
      rules: {
        nationality: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.nationality
      ) {
        this.$set(this.form, 'nationality', {
          id: '' + (this.$props.data.nationality.id ? this.$props.data.nationality.id : ''),
          content: this.$props.data.nationality.content ? this.$props.data.nationality.content : ''
        })
      } else {
        this.$set(this.form, 'nationality', {
          id: 'new_nationality',
          content: ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: 'nationality'
        }
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['nationality', 'all'].includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.status.editing === 'nationality'
      )
    },
    isLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        ['nationality', 'all'].includes(this.$props.status.loading)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.status.loading === 'nationality'
      )
    },
    getNationItems () {
      return Object.keys(this.$mango.nations).map(key => {
        return {
          code: key,
          label: this.$mango.nations[key]
        }
      })
    },
    printNationality () {
      return (
        this.$props.data &&
        this.$props.data.nationality &&
        this.$props.data.nationality.content &&
        this.$mango.nations[this.$props.data.nationality.content]
      ) ? this.$mango.nations[this.$props.data.nationality.content] : '国籍'
    },
    isPrintEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.nationality &&
        this.$props.data.nationality.content &&
        this.$mango.nations[this.$props.data.nationality.content]
      )
    }
  }
}
</script>
